import styled from 'styled-components/macro'
import { ModalHeader } from 'reactstrap'

const Header = styled(ModalHeader)`
  & .modal-title {
    display: flex;
    flex-direction: row;
    justify-content: space-between;
    width: 100%;
  }
`

export { Header }
